<template>
  <div
    class="cleanTransport_container"
    :class="[
      styleType == 'typeGreen'
        ? 'cleanTransport_container_green'
        : styleType == 'typeBlue'
        ? 'cleanTransport_container_blue'
        : '',
        ismiddleClean ? 'cleanTransport_container_green_middle' : '',
    ]"
  >
    <main
      v-if="isDoor && refreshTag"
      class="index-page"
      style="pointer-events: auto"
      :class="{ isThinStyle: isThin }"
    >
      <div class="left_box">
        <carMonitorStatistics v-if="refreshTag" />
      </div>
      <div class="right_box">
        <cleanStatistics v-if="refreshTag" />
      </div>
      <div
        v-show="$store.state.customerId == 22"
        @click="returnMain"
        class="return_btn"
      ></div>
    </main>
  </div>
</template>

<script>
import carMonitorStatistics from "@/modules/cleanTransportComponents/carMonitorStatistics";
import cleanStatistics from "@/modules/cleanTransportComponents/cleanStatistics";
import { mapState } from "vuex";
import { dateFormat } from "utils/tools";

export default {
  components: { carMonitorStatistics, cleanStatistics },
  data() {
    //这里存放数据
    return {
      pageInfo: "CleanTransportMod.vue",
      computedName: "清洁运输首页组件",
      isDoor: false,
      customerId: this.$store.state.customerId,
      refreshTag: true,
      styleType: "",
      isThin: bmeConfig.isThin,
      isPublicCleanTransport: bmeConfig.isPublicCleanTransport,
      baseUrl: bmeConfig.baseUrl,
      ismiddleClean: bmeConfig.ismiddleClean,
    };
  },
  //计算属性 类似于data概念
  computed: {
    curStyleTypeVal() {
      return this.$store.state.styleType;
    },
  },
  created() {
    this.styleType = this.$store.state.styleType;
    this.ismiddleClean = bmeConfig.ismiddleClean
  },
  mounted() {
    this.getVideoConf();
    if (this.customerId != 94 && this.customerId != 60) {
      this.getVersionConfig();
    }
  },
  errorCaptured(error, vm, info) {
    console.log("kk-", error, vm, info);
    let msg = "错误信息：" + error + "，错误详情：" + info;
    let computedName = vm.mtitle || vm.computedName;
    return false;
    // this.requestExceptCap(msg,instance);
  },
  watch: {
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal;
      },
      deep: true,
    },
  },
  //方法集合
  methods: {
    /**
     * @Description: 全局异常捕获上传
     * @param {String} msg 报错信息
     * @param {Object} instance 报错组件
     * @return void
     * @author liqiuyu
     * @date 2024/3/12
     */
    requestExceptCap(msg, instance) {
      const date = new Date();
      const time = dateFormat("YYYY-mm-dd HH:MM:SS", date);
      const url = this.$apiOpt.platformCollect;

      const param = {
        firstLevelCode: "notOpen",
        secondLevelCode: "beforeError",
        additionalInfo: {
          source: "screen",
          mac: "867788sjgdjbsd",
          customerId: window.bmeConfig.customerSign,
          sourceFile: instance,
          sourcePage: instance,
          time: time,
          msg: msg,
        },
      };
      this.$apiUtils
        .post(url, param)
        .then((res) => {})
        .catch((error) => {});
    },
    /**
     * @Description: 获取新门禁字段标识
     * @author liqiuyu
     * @date 2023/4/18
     * @return void
     */
    async getVersionConfig() {
      let url, res;
      url =
        this.baseUrl + `/${CONFIG.requestName}/queryAccessVersionConfiguration`;
      if (this.customerId == 154) { // 太钢鑫海清洁运输前缀单独处理
        url =
        this.baseUrl + `/bme-access-control/queryAccessVersionConfiguration`;
      }  
      res = await this.$apiUtils.get3(url, {
        customerId: this.customerId,
      });
      if (res) {
        let newAccessType = res.is_zhang_access == 1 ? true : false;
        this.$store.commit("updateNewAccessType", newAccessType);
      }
    },
    returnMain() {
      this.$router.push({ path: "/MainMod" });
      this.$store.commit("changeTitleViews", "主页");
    },
    async getVideoConf() {
      let videoConfData;
      if (
        this.isPublicCleanTransport &&
        this.customerId !== 19 &&
        this.customerId !== 58
      ) {
        videoConfData = this.baseUrl + `/${CONFIG.requestName}`;
        if (this.customerId == 154) { // 太钢鑫海清洁运输前缀单独处理
          videoConfData = this.baseUrl + `/bme-access-control`;
        }
      } else {
        let getVideoConf = CONFIG.requestName + this.$apiOpt.getVideoConf;
        videoConfData = await this.$apiUtils.get(getVideoConf, {
          customerId: this.customerId,
        });
        if (videoConfData) {
          videoConfData = videoConfData.cleanTransportIp;
        }
      }

      this.$store.commit("getVideoConfAction", videoConfData);
      this.isDoor = true;
    },
    reload() {
      this.refreshTag = false;
      this.$nextTick(function () {
        this.refreshTag = true;
        this.getVideoConf();
      });
    },
  },
  // beforeRouteUpdate(to, from) {
  //  debugger
  //   this.reload();
  // },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped="scoped">
.cleanTransport_container {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
  background: url("/static/images/common/cleanTransportBg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.cleanTransport_container_green {
  background: url("/static/images/common/cleanTransportBg_green.png") !important;
}
.cleanTransport_container_green_middle {
  background: url("/static/images/common/cleanTransportBg_green.png") !important;
  width: 3840px;
  height: 1080px;
  transform-origin: left center;
  transform: scaleX(0.63);
}
.cleanTransport_container_blue {
  z-index: 998;
  background: url("/static/img/blue_bg.png") no-repeat center center;
  background-size: 100% 100% !important;
  padding: 0 30px;
  box-sizing: border-box;
  main {
    background: url("/static/images/common/cleanTransportBg_blue.png") no-repeat
      center center !important;
    z-index: 998;
    width: 100%;
    height: 100%;
    background-size: 100% auto !important;
    box-sizing: border-box;
  }
}
.index-page {
  height: 100%;
  position: relative;
  .left_box {
    position: absolute;
    left: 0px;
    top: 0px;
    margin-top: 160px;
    width: 65%;
    height: 790px;
    padding-left: 50px;
  }
  .right_box {
    position: absolute;
    right: 0px;
    top: 0px;
    margin-top: 160px;
    width: 35%;
    height: 790px;
    padding-right: 50px;
  }
}
:deep(.self_btn) {
  width: 82px;
  height: 37px;
  line-height: 34px;
  margin-top: 5px;
}
.isThinStyle {
  transform: scale(1, 0.8) !important;
}
</style>

<style>
.cleanTransport_container .el-input__inner {
  background: none !important;
}
.cleanTransport_container_green .el-form-item__content .el-date-editor,
.el-form-item__content .el-date-editor input {
  color: rgba(5, 255, 250, 0.8) !important;
}

.isThinStyle .el-date-editor {
  width: 245px !important;
}
.isThinStyle .door_title {
  display: block;
}
.isThinStyle .door-box .public-form,
.isThinStyle .door-box .box-wrap {
  padding: 0px !important;
}
.return_btn {
  position: absolute;
  right: 100px;
  top: 120px;
  width: 125px;
  height: 38px;
  background-image: url("../../assets/img/components_bg/comeback.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  cursor: pointer;
}
.return_btn:hover {
  background-image: url("../../assets/img/components_bg/comeback_active.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>
